/**
 * Local product preview images.
 *
 * Every file in src/assets/products is picked up at build time and keyed by
 * its filename, so adding a preview is "drop the file in, name it after the
 * product's slug" — no import and no edit here. See that folder's README for
 * the naming convention and the export size.
 */

/* eslint-disable no-undef */
const ctx = require.context(
  "../assets/products",
  false,
  /\.(webp|avif|png|jpe?g)$/i
);

/* Match loosely so "name-pilot", "namepilot" and "NamePilot" all resolve to
   the same product — a dropped file should never fail silently over a dash. */
const normalise = (s) => String(s).toLowerCase().replace(/[^a-z0-9]/g, "");

const byName = {};
ctx.keys().forEach((key) => {
  const file = key.replace(/^\.\//, "").replace(/\.[^.]+$/, "");
  const mod = ctx(key);
  const url = mod && mod.default ? mod.default : mod;
  byName[file] = url;
  byName[normalise(file)] = url;
});

/** Generic placeholder, used when a product has no image of its own. */
export const defaultProductImage = byName._default || null;

/** Local image for a product slug, or the generic placeholder. */
export function productImage(slug) {
  if (!slug) return defaultProductImage;
  return byName[slug] || byName[normalise(slug)] || defaultProductImage;
}

export default byName;
